import { render, staticRenderFns } from "./costInfo.vue?vue&type=template&id=3f392bf6&scoped=true&"
import script from "./costInfo.vue?vue&type=script&lang=js&"
export * from "./costInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f392bf6",
  null
  
)

export default component.exports